import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('sheet_rate_identifiers')
const reducer = generator.generate()

export default reducer
